"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FieldPreviewPrimary = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var React = _interopRequireWildcard(require("react"));

var _usePkpass2 = require("../../../usePkpass");

var _types = require("../../../../../../types");

var _FieldPreviewValue = require("./FieldPreviewValue");

var _FieldPreviewLabel = require("./FieldPreviewLabel");

var _Theme = require("../../../../Theme");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FieldPreviewPrimary = function FieldPreviewPrimary(props) {
  var _usePkpass = (0, _usePkpass2.usePkpass)(),
      pass = _usePkpass.pass,
      language = _usePkpass.language,
      passStyle = _usePkpass.passStyle;

  var theme = (0, _Theme.useTheme)();
  var values = props.values;

  if (passStyle === _types.PkpassPassStyleTypes.EventTicket) {
    return /*#__PURE__*/React.createElement("div", {
      style: {
        color: pass.foregroundColor,
        maxWidth: theme.scale * 290,
        verticalAlign: 'middle'
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        color: 'white',
        fontSize: theme.scale * 40,
        height: theme.scale * 50,
        lineHeight: "".concat(theme.scale * 40, "px"),
        marginTop: theme.scale * 20,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
      }
    }, (0, _FieldPreviewValue.getValueValue)(values, language)));
  }

  if (passStyle === _types.PkpassPassStyleTypes.StoreCard || passStyle === _types.PkpassPassStyleTypes.Coupon) {
    return /*#__PURE__*/React.createElement("div", {
      style: {
        color: pass.foregroundColor,
        maxWidth: theme.scale * 290
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        color: 'white',
        fontSize: theme.scale * 38,
        height: theme.scale * 40,
        lineHeight: "".concat(theme.scale * 38, "px"),
        marginTop: theme.scale * 30,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
      }
    }, (0, _FieldPreviewValue.getValueValue)(values, language) || /*#__PURE__*/React.createElement("span", null, "\xA0")), /*#__PURE__*/React.createElement("div", {
      style: {
        color: 'white',
        fontSize: theme.scale * 15,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        textTransform: 'uppercase',
        whiteSpace: 'nowrap'
      }
    }, (0, _FieldPreviewLabel.getLabelValue)(values, language)));
  }

  if (passStyle === _types.PkpassPassStyleTypes.BoardingPass) {
    return /*#__PURE__*/React.createElement("div", {
      style: {
        color: pass.foregroundColor
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        color: pass.labelColor,
        fontSize: theme.scale * 10,
        height: "".concat(theme.scale * 1.3, "em"),
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        textTransform: 'uppercase',
        whiteSpace: 'nowrap'
      }
    }, (0, _FieldPreviewLabel.getLabelValue)(values, language)), /*#__PURE__*/React.createElement("div", {
      style: {
        color: pass.foregroundColor,
        fontSize: theme.scale * 30,
        height: theme.scale * 34,
        lineHeight: "".concat(theme.scale * 30, "px"),
        marginTop: theme.scale * 10,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
      }
    }, (0, _FieldPreviewValue.getValueValue)(values, language)));
  }

  if (passStyle === _types.PkpassPassStyleTypes.Generic) {
    return /*#__PURE__*/React.createElement("div", {
      style: {
        color: pass.foregroundColor,
        maxWidth: 200
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        color: pass.labelColor,
        fontSize: 10,
        height: '1.3em',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        textTransform: 'uppercase',
        whiteSpace: 'nowrap'
      }
    }, (0, _FieldPreviewLabel.getLabelValue)(values, language)), /*#__PURE__*/React.createElement("div", {
      style: {
        color: pass.foregroundColor,
        fontSize: 30,
        height: 34,
        lineHeight: '30px',
        marginTop: 10,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
      }
    }, (0, _FieldPreviewValue.getValueValue)(values, language)));
  }

  return null;
};

exports.FieldPreviewPrimary = FieldPreviewPrimary;
//# sourceMappingURL=FieldPreviewPrimary.js.map